module.exports = __webpack_public_path__ + "static/media/myriad-pharmaceuticals-main.f10931bf.png";